import { AccountCircle, ArrowForwardIos } from "@mui/icons-material";
import { AlertColor, Box, Checkbox, Grid, Link, Paper } from "@mui/material";
import { KeyDriveh4Header } from "../../../../components/KeydriveComponents/Fonts/Headers/KeyDriveh4Header";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeydriveTextfield } from "../../../../components/KeydriveComponents/Textfield/KeydriveTextfield";
import KeyDriveWordDivider from "../../../../components/KeydriveComponents/Dividers/KeydriveOrDivider";
import CustomButton from "../../Login/CustomButton";
import { KeyDrivePrimaryButton } from "../../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { KeyDriveBodyMax } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import microsoftIcon from '../../../../assets/icons/Microsoft_logo_(2012).svg';
import { useTranslation } from "react-i18next";
import { IRegisterUserObject, IStepHandler, IStepItem } from "../Register";
import RegisterAccount from "./Steps/RegisterAccount";
import RegisterPassword from "./Steps/RegisterPassword";
import RegisterOrganization from "./Steps/RegisterOrganization";
import RegisterPlan from "./Steps/RegisterPlan";
import ConcludedWizard from "./Steps/ConcludedWizard";
import EmailSended from "./Steps/EmailSended";

export interface IRegisterPageRight {
    setCreateUserObject: (set: IRegisterUserObject) => void;
    createUserObject: IRegisterUserObject;
    step: number;
    setStep: (set: number) => void;
    forwardStep: () => void;
    backStep: () => void;
    setAlertColor: (set: AlertColor) => void;
    setMessage: (set: string) => void;
    setSendEmailOk: (set: boolean) => void;
    setPrivacyOk: (set: boolean) => void;
    emailOk: boolean;
    privacyOk: boolean;
    stepList: IStepItem[];
}

export default function RegisterPageRight({
    setCreateUserObject,
    createUserObject,
    step,
    setStep,
    forwardStep,
    backStep,
    setAlertColor,
    setMessage,
    setPrivacyOk,
    setSendEmailOk,
    emailOk,
    privacyOk,
    stepList
}: IRegisterPageRight) {

    // handlers

    function emailHandler(input: string): void {
        setCreateUserObject({
            ...createUserObject,
            email: input
        });
    }

    function usernameHandler(input: string): void {
        setCreateUserObject({
            ...createUserObject,
            username: input
        });
    }

    function passwordHandler(input: string): void {
        setCreateUserObject({
            ...createUserObject,
            password: input
        });
    }

    function confirmPasswordHandler(input: string): void {
        setCreateUserObject({
            ...createUserObject,
            confirmPassword: input
        });
    }
    
    function organizationHandler(input: string): void {
        setCreateUserObject({
            ...createUserObject,
            organizationName: input
        });
    }

    function privacyOkHandler(input: boolean) {
        setCreateUserObject({
            ...createUserObject,
            privacyOk: privacyOk
        })
    }

    function emailOkHandler(input: boolean) {
        setCreateUserObject({
            ...createUserObject,
            emailOk: emailOk
        })
    }

    function paperHeightHandler(): string {
        switch(step) {
            case 3:
                return "379px"
            case 4:
                return "554px"
            case 6:
                return "261px"
            default:
                return "645px"
        }
    }

    return (
            <Grid item xs={5} display="flex" alignItems="center" justifyContent="center">
                <Paper
                    elevation={3}
                    sx={{
                        width: "560px",
                        height: `${paperHeightHandler()}`,
                        padding: "40px"
                    }}
                >
                    <Grid container>
                        { step == 1 && (
                            <RegisterAccount
                                createUserObject={createUserObject}
                                emailHandler={emailHandler}
                                usernameHandler={usernameHandler}
                                key={1}
                                forwardStep={forwardStep}
                                backStep={backStep}
                                setMessage={setMessage}
                                setAlertColor={setAlertColor}
                                setPrivacyOk={setPrivacyOk}
                                setSendEmailOk={setSendEmailOk}
                                emailOk={emailOk}
                                privacyOk={privacyOk}
                                privacyOkHandler={privacyOkHandler}
                                emailOkHandler={emailOkHandler}
                                setCreateUserObject={setCreateUserObject}
                            />
                        ) }

                        { step == 2 && (
                            <RegisterPassword
                                backStep={backStep}
                                confirmPasswordHandler={confirmPasswordHandler}
                                createUserObject={createUserObject}
                                forwardStep={forwardStep}
                                passwordHandler={passwordHandler}
                                key={2}
                                setMessage={setMessage}
                                setAlertColor={setAlertColor}
                            />
                        ) }

                        { step == 3 && (
                            <RegisterOrganization 
                                createUserObject={createUserObject}
                                organizationHandler={organizationHandler}
                                backStep={backStep}
                                forwardStep={forwardStep}
                                setMessage={setMessage}
                                setAlertColor={setAlertColor}
                            />
                        ) }

                        { step == 4 && (
                            <ConcludedWizard 
                                backStep={backStep}
                                forwardStep={forwardStep}
                                createUserObject={createUserObject}
                                setMessage={setMessage}
                                setAlertColor={setAlertColor}
                                stepList={stepList}
                                setStep={setStep}
                                step={step}
                            />
                        ) }
                        
                        { step == 6 && (
                            <EmailSended />
                        ) }

                    </Grid>
                </Paper>
            </Grid>
    )
}